import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  IconButton,
  Alert,
  CircularProgress
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomButton from "../../../../components/CustomButton/Button";

interface UnsubscribeMembershipDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
  error: string;
  establishmentName: string;
}

const UnsubscribeMembershipDialog: React.FC<UnsubscribeMembershipDialogProps> =
  ({ open, onClose, onConfirm, loading, error, establishmentName }) => {
    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography sx={{ fontWeight: 600, fontSize: "18px" }}>
              Confirm Unsubscription
            </Typography>
            <IconButton aria-label="close" onClick={onClose} disabled={loading}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          <Typography>
            Are you sure you want to unsubscribe from the membership for{" "}
            <strong>{establishmentName}</strong>? This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <CustomButton callBack={onClose} disabled={loading}>
            Cancel
          </CustomButton>
          <CustomButton callBack={onConfirm} disabled={loading}>
            {loading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              "Unsubscribe"
            )}
          </CustomButton>
        </DialogActions>
      </Dialog>
    );
  };

export default UnsubscribeMembershipDialog;
